<script>
import { mapActions } from 'vuex'

import MultiSelect from 'vue-multiselect'

import InputWrapper from '@/components/UI/FormGroupWrappers/InputWrapper.vue'

export default {
	name: 'SelectFish',
	components: {
		MultiSelect,
		InputWrapper,
	},
	props: {
		withTitle: {
			type: Boolean,
			default: true,
		},
		title: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		max: {
			type: Number,
			default: null,
		},
		errors: {
			type: Object,
			default: null,
		},
		name: {
			type: String,
			default: '',
		},
		filters: {
			type: Object,
			default: () => ({}),
		},
		required: {
			type: Boolean,
			default: false,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		value: {
			type: [Object, Array],
			default: null,
		},
		confinesValue: {
			type: Array,
			default: () => [],
		},
		// id рыб, которые не показывать в списке (например, уже выбранные в соседних строках)
		excludeIds: {
			type: Array,
			default: () => [],
		},
		watchValue: null,
		watchValues: {
			type: Array,
			default: () => [],
		},
	},
	emits: ['input'],
	computed: {
		modelValue: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			},
		},
		options() {
			const excluded = this.excludeIds.map(Number)
			const fishes = (this.$store.state.catalogs.fishes || []).filter(
				(item) => !excluded.includes(Number(item.id)),
			)
			const allItems = [
				{
					source: this.$t('labels.restItems'),
					items: fishes.filter(
						(item) => !this.confinesValue?.some((confine) => confine.id === item.id),
					),
				},
			]
			if (this.confinesValue?.length) {
				allItems.unshift({
					source: this.$t('labels.byQuota'),
					items: fishes.filter((item) =>
						this.confinesValue?.some((confine) => confine.id === item.id),
					),
				})
			}
			return allItems
		},
	},
	watch: {
		watchValue() {
			this.$emit('input', null)
		},
		// watchValues: {
		// 	handler(newValue, oldValue) {
		// 		if (!this.watchValues?.length || JSON.stringify(newValue) === JSON.stringify(oldValue))
		// 			return
		// 		if (
		// 			Object.entries(this.filters).every(([_, value]) => value?.length && value.every((i) => i))
		// 		) {
		// 			this._fetchFishes(this.filters)
		// 		}
		// 		this.$emit('input', null)
		// 	},
		// },
	},
	methods: {
		...mapActions(['_fetchFishes']),
	},
	async beforeMount() {
		// if (!this.watchValues?.length) await this._fetchFishes()
		await this._fetchFishes()
	},
}
</script>

<template>
	<InputWrapper
		class="select-region"
		:title="withTitle ? title || '' : ''"
		:is-error="errors && errors.$error"
		:error="errors && !errors.required ? $t('system_message.required_message') : ''"
	>
		<MultiSelect
			track-by="id"
			label="title"
			class="multiselect__check"
			:max="multiple && max"
			:preserve-search="true"
			:required="required"
			:multiple="multiple"
			:close-on-select="!multiple"
			:placeholder="placeholder"
			:disabled="disabled"
			:options="options"
			group-label="source"
			group-values="items"
			:group-select="false"
			v-model="modelValue"
		>
			<template slot="option" slot-scope="{ option }">
				<span v-if="option.$isLabel && confinesValue?.length" class="group-title">{{
					option.$groupLabel
				}}</span>
				<span v-else>{{ option.title }}</span>
			</template>
			<template slot="noResult">{{ $t('components.not_found') }}</template>
			<template slot="noOptions">{{ $t('components.not_found') }}</template>
			<template slot="placeholder">{{ placeholder || $t('placeholder.choose') }}</template>
		</MultiSelect>
	</InputWrapper>
</template>

<style>
.select-region .multiselect__tags {
	padding-left: 20px;
	border-radius: 5px;
	background: #ffffff;
	border: 1px solid #157fee !important;
	font-weight: 400;
	font-size: 14px;
	color: #0a091d;
	line-height: 1.2;
	width: 100%;
}

.select-region .multiselect--disabled .multiselect__tags {
	border: 1px solid #d3e7fb;
}

.select-region .multiselect--disabled .multiselect__placeholder {
	margin-bottom: 0;
}

.select-region .multiselect__single {
	margin-bottom: 0;
}

.select-region .input-body--error.input-body .multiselect__tags {
	border-color: #f3574d;
}

.select-region .input-body--error + .input-required {
	display: block;
}
</style>
